import React from "react"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"
import WPCta from "../_base/WPCta"

import CloudflareStream from "../_base/CloudflareStream"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as heroSectionChampionshipStyles from "../../styles/world_championships/HeroSectionChampionship.module.css"

const HeroSectionChampionship = props => {
  const { content } = props

  const titleWords = ChildSelector.select(
    content,
    `championship-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const creditsIntro = ChildSelector.select(
    content,
    `championship-credits-intro`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const info = ChildSelector.select(
    content,
    `championship-content`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <div
      className={`row g-0 ${props.className} ${heroSectionChampionshipStyles.wrapper}`}
    >
      <div className="col-12">
        <div style={{ display: "grid", gridAutoRows: "1fr" }}>
          <div
            style={{
              gridArea: "1/1",
              position: "relative",
              placeItems: "left",
              display: "grid",
              zIndex: 2,
            }}
          >
            <div className={`row g-0`}>
              <div
                className={`col-12 ${heroSectionChampionshipStyles.content}`}
              >
            {/*     <div className={`row g-0`}>
                  <div
                    className={`d-none d-lg-block col-12 col-lg-6 ${heroSectionChampionshipStyles.heading}`}
                  >
                    <WPCta
                      holder={content}
                      selector={`championship-register`}
                      translate={false}
                      className={`d-none d-lg-flex ${heroSectionChampionshipStyles.register}`}
                    />
                  </div>
                  <div
                    className={`col-12 col-lg-6 ${heroSectionChampionshipStyles.credits}`}
                  >
                    <p className={`${heroSectionChampionshipStyles.intro}`}>
                      {creditsIntro}
                    </p>
                    <img src={whiteLogo} alt="Cubewise" />
                  </div>
                </div> */}
                <div className={`row g-0`}>
                  <div
                    className={`col-12 ${heroSectionChampionshipStyles.naming}`}
                  >
                    
                    <WPImage
                      holder={content}
                      selector={`championship-logo`}
                      mode={DISPLAY_MODE.normal}
                      className={`${heroSectionChampionshipStyles.championshipLogo}`}
                    />
                    <h1 className={`${heroSectionChampionshipStyles.information}`}>
                      {titleWords}
                    </h1>
                    
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <div
            className={`${heroSectionChampionshipStyles.backgroundContainmentImage}`}
            style={{
              gridArea: "1/1",
              objectFit: "cover",
              placeItems: "right",
              zIndex: 1,
            }}
            objectfit="cover"
            placeholderstyle={{
              objectFit: `cover`,
              objectPosition: `right bottom`,
            }}
            imgstyle={{
              objectFit: `cover`,
              objectPosition: `right bottom`,
            }}
            transformoptions={{ fit: "cover" }}
          >
           {/*  <span
              className={`d-none d-lg-flex ${heroSectionChampionshipStyles.backgroundImage}`}
            >
              <CloudflareStream videoStreamId="90f3ec5ab46ae62336f154dccb2fb8bd" />
            </span> */}
            <WPImage
              holder={content}
              selector={`media-asset`}
              mode={DISPLAY_MODE.normal}
              className={`d-flex d-lg-none ${heroSectionChampionshipStyles.backgroundImage}`}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroSectionChampionship
